function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilled202X202Px = function SvgFilled202X202Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 202 202",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m125.4 10 68.8 71.6c11.5 11.9 10.9 30.8-1.2 42.1l-72.8 67.7c-12.1 11.3-31.3 10.7-42.8-1.2L8.6 118.5c-11.5-11.9-10.9-30.8 1.2-42L82.6 8.8C94.8-2.5 113.9-1.9 125.4 10",
    style: {
      fill: "#e2001a"
    }
  }));
};
export default SvgFilled202X202Px;